import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import { md3 } from "vuetify/blueprints";

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    blueprint: md3,

    // Custom theme configuration
    theme: {
      defaultTheme: "light",
      themes: {
        light: {
          colors: {
            primary: "2B478B",
            secondary: "#4c6ea0",
            surface: "#ffffff",
          },
        },
      },
    },
  });
  app.vueApp.use(vuetify);
});
